import { IntradayDataPoint } from "@bloomberg/octagon-shared";
import { marketDataClient } from "~config/octagon-client";
import type { IntradayChartData } from "~types/types";
import { logError } from "~utils/newrelic/newrelicBrowser";

const mc = marketDataClient.getInstance();

export const fetchIntradayChartData = async (
  tickers: Array<string>,
  tradingDayCount = 1,
  dataPoints: IntradayDataPoint = IntradayDataPoint.Close,
  intervalMinutes?: number,
  referenceFields?: string,
  includeOutOfSessionBars = false
): Promise<IntradayChartData[]> => {
  try {
    const intradayResponse = await mc.getIntraday({
      securities: tickers.join(","),
      dataPoints,
      intervalMinutes,
      tradingDayCount,
      referenceFields,
      includeOutOfSessionBars,
    });

    return intradayResponse as unknown as IntradayChartData[];
  } catch (error) {
    logError(new Error("Error Fetching IntradayChartData"), {
      context: "fetchIntradayChartData",
      tickers,
      errorMsg: JSON.stringify(error),
    });

    throw new Error(
      `Failed to fetch intradayChartData for ${tickers.join(", ")}`
    );
  }
};

export const fetchIntradayChartDataWithDates = async (
  tickers: Array<string>,
  startDate: string,
  endDate: string,
  dataPoints: IntradayDataPoint = IntradayDataPoint.Close,
  intervalMinutes?: number,
  referenceFields?: string,
  includeOutOfSessionBars = false
): Promise<IntradayChartData[]> => {
  try {
    const intradayResponse = await mc.getIntraday({
      securities: tickers.join(","),
      dataPoints,
      intervalMinutes,
      startDate,
      endDate,
      referenceFields,
      includeOutOfSessionBars,
    });

    return intradayResponse as IntradayChartData[];
  } catch (error) {
    logError(new Error("Error Fetching IntradayChartData With Dates"), {
      context: "fetchIntradayChartData",
      tickers,
      errorMsg: JSON.stringify(error),
    });

    throw new Error(
      `Failed to fetch intradayChartData for ${tickers.join(", ")}`
    );
  }
};
